import React, { useEffect, useState } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  useLocation,
} from "react-router-dom";
import Home from "./components/pages/Home";
import Contact from "./components/pages/Contact";
import MakePayment from "./components/pages/MakePayment";
import About from "./components/pages/About";
import CookieConsentDialog from "./components/CookieDialog";
import CookiePolicy from "./components/pages/CookiePolicy";
import CookieProvider, { useCookie } from "./context/CookieProvider";
import Help from "./components/pages/Help";
import RebrandArticle from "./components/pages/RebrandArticle";
import FinanceControlArticle from "./components/pages/FinanceControlArticle";
import PayingTooMuchArticle from "./components/pages/PayingTooMuchArticle";
import Faqs from "./components/pages/Faqs";
import ScrollToTop from "./components/ScrollToTop";
import PaymentSuccess from "./components/pages/PaymentSuccess";
import PaymentFailed from "./components/pages/PaymentFailed";

const LayoutWrapper = () => {
  const { getCookie, setCookie } = useCookie();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [consent, setConsent] = useState(null);

  useEffect(() => {
    const initialConsent = getCookie("google_analytics");
    setConsent(initialConsent || null);
  }, [getCookie]);

  useEffect(() => {
    if (consent === null && location.pathname !== "/CookiePolicy") {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [location.pathname, consent]);

  const handleAccept = () => {
    setCookie("google_analytics", "accepted", 365, "/");
    setConsent("accepted");
    setOpen(false);
  };

  const handleDecline = () => {
    setCookie("google_analytics", "declined", 365, "/");
    setConsent("declined");
    setOpen(false);
  };

  useEffect(() => {
    if (consent === "accepted" && !window.gtag) {
      const script = document.createElement("script");
      script.src = "https://www.googletagmanager.com/gtag/js?id=G-28BGWEZ4ZV";
      script.async = true;
      document.head.appendChild(script);

      script.onload = () => {
        window.dataLayer = window.dataLayer || [];
        function gtag() { window.dataLayer.push(arguments); }
        window.gtag = gtag;
        gtag("js", new Date());
        gtag("config", "G-28BGWEZ4ZV", {
          send_page_view: false,
        });

        gtag("event", "page_view", {
          page_path: location.pathname + location.search,
        });
      };
    }
  }, [consent]);

  useEffect(() => {
    if (consent === "accepted" && window.gtag) {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
      });
    }
  }, [location.pathname, location.search, consent]);

  return (
    <>
      <ScrollToTop />
      <Outlet />
      <CookieConsentDialog
        open={open}
        onClose={() => setOpen(false)}
        onAccept={handleAccept}
        onDecline={handleDecline}
      />
    </>
  );
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <LayoutWrapper />,
    children: [
      { index: true, element: <Home /> },
      { path: "Contact", element: <Contact /> },
      { path: "About", element: <About /> },
      { path: "MakePayment", element: <MakePayment /> },
      { path: "RebrandArticle", element: <RebrandArticle /> },
      { path: "FinanceControlArticle", element: <FinanceControlArticle /> },
      { path: "PayingTooMuchArticle", element: <PayingTooMuchArticle /> },
      { path: "Faqs", element: <Faqs /> },
      { path: "Help", element: <Help /> },
      { path: "CookiePolicy", element: <CookiePolicy /> },
      { path: "making-repayments/thank-you", element: <PaymentSuccess /> },
      { path: "making-repayments/sorry", element: <PaymentFailed /> },
    ],
  },
]);

function App() {
  return (
    <CookieProvider>
      <RouterProvider router={router} />
    </CookieProvider>
  );
}

export default App;
